var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.33333 1.33325V3.99992M9.66667 1.33325V3.99992M1 6.66659H13M4.33333 9.33325H4.34M7 9.33325H7.00667M9.66667 9.33325H9.67333M4.33333 11.9999H4.34M7 11.9999H7.00667M9.66667 11.9999H9.67333M2.33333 2.66659H11.6667C12.403 2.66659 13 3.26354 13 3.99992V13.3333C13 14.0696 12.403 14.6666 11.6667 14.6666H2.33333C1.59695 14.6666 1 14.0696 1 13.3333V3.99992C1 3.26354 1.59695 2.66659 2.33333 2.66659Z",
    stroke: "#566985",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCalendar);
export default __webpack_public_path__ + "static/media/grey-calendar.a1158e68c6d2aa46cbd6c2ea1d39c47a.svg";
export { ForwardRef as ReactComponent };